<template>
  <q-space></q-space>
</template>

<script>
  export default {
    name: 'MiSpace'
  }
</script>
